var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"hello"},[_c('i',[_vm._v("欢迎使用晨星平台")])])])])
}]

export { render, staticRenderFns }